import React from 'react';

const SystemSettings = () => {
  return (
    <div className="min-h-screen pt-24 bg-gray-50">
      <div className="container-custom">
        <h1 className="text-3xl font-bold text-gray-900">System Settings</h1>
        <p className="text-gray-600 mt-2">System settings coming soon.</p>
      </div>
    </div>
  );
};

export default SystemSettings;